<!-- INÍCIO DO CONTEÚDO -->
<section class="content-header">
    <h1>Sobre</h1>
  </section>

  <section class="content">
      <p class="lead">
        deliveryApp | Aplicação de Delivery de Comida
      </p>
      <p class="lead">
        MIT license
      </p>
      <p class="lead">Copyright 2017 Rodrigues Mafumo (<a href="http://www.rodriguesmafumo.com">http://www.rodriguesmafumo.com</a>)</p>
      <p class="lead">Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>
      <p class="lead">The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.            </p>
      <p class="lead">
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
      <p class="lead">
        Imagens usadas na aplicação por <a href="http://www.freepik.com" target="_blank">freepik.com</a>
      </p>

    </section>
<!-- FIM DO CONTEÚDO -->
